import React from 'react';
import clsx from 'clsx';
import styles from './DivisionCountCell.module.css';

export interface DivisionCountCellProps {
  count: number;
  icon: React.ReactNode;
  className?: string;
}

const DivisionCountCell: React.FC<DivisionCountCellProps> = ({ count, icon, className }) => {
  return (
    <div className={clsx(styles.countCell, className)}>
      {icon}
      <span>{count}</span>
    </div>
  );
};

export default DivisionCountCell;
